import { apiClient } from '@/lib/api-client'

// Types
export interface DLQQueueInfo {
  name: string
  url: string
  message_count: number
  source_queue_name: string | null
}

export interface DLQQueuesResponse {
  queues: DLQQueueInfo[]
  total_messages: number
}

export interface DLQMessageAttribute {
  data_type: string
  value: string
}

export interface DLQMessage {
  message_id: string
  receipt_handle: string
  body: unknown
  body_raw: string
  attributes: Record<string, string>
  message_attributes: Record<string, DLQMessageAttribute>
  sent_timestamp: string | null
  approximate_receive_count: number
}

export interface DLQMessagesResponse {
  queue_name: string
  messages: DLQMessage[]
  count: number
}

export interface DLQRedriveRequest {
  message_ids?: string[]
}

export interface DLQRedriveResponse {
  queue_name: string
  redriven_count: number
  failed_count: number
  errors: string[]
}

export interface DLQDeleteResponse {
  queue_name: string
  deleted: boolean
  message_id: string | null
}

export interface DLQPurgeResponse {
  queue_name: string
  purged: boolean
  approximate_messages_deleted: number
}

// API functions
export async function getDLQQueues(): Promise<DLQQueuesResponse> {
  const response = await apiClient.get<DLQQueuesResponse>('/api/v1/admin/dlq')
  return response.data
}

export async function getDLQMessages(
  queueName: string,
  maxMessages = 10,
): Promise<DLQMessagesResponse> {
  const response = await apiClient.get<DLQMessagesResponse>(
    `/api/v1/admin/dlq/${queueName}/messages`,
    {
      params: { max_messages: maxMessages },
    },
  )
  return response.data
}

export async function redriveMessages(
  queueName: string,
  messageIds?: string[],
): Promise<DLQRedriveResponse> {
  const response = await apiClient.post<DLQRedriveResponse>(
    `/api/v1/admin/dlq/${queueName}/redrive`,
    messageIds ? { message_ids: messageIds } : {},
  )
  return response.data
}

export async function deleteMessage(
  queueName: string,
  receiptHandle: string,
): Promise<DLQDeleteResponse> {
  const response = await apiClient.delete<DLQDeleteResponse>(
    `/api/v1/admin/dlq/${queueName}/messages/${encodeURIComponent(receiptHandle)}`,
  )
  return response.data
}

export async function purgeQueue(queueName: string): Promise<DLQPurgeResponse> {
  const response = await apiClient.delete<DLQPurgeResponse>(`/api/v1/admin/dlq/${queueName}/purge`)
  return response.data
}
